import { useMutation } from "@apollo/client";
import { Form } from "@/shared/components";
import { CrudDialog } from "./CrudDialog";
import { CrudDialogHeader } from "./CrudDialogHeader";
import type { Breakpoint } from "@mui/material/styles";

export interface CrudCreateDialogProps<FormData = any> {
  open: boolean;
  onClose: () => void;
  onSubmitSuccess: (data: any) => void;
  createSchema: any;
  texts: {
    createItem: string;
    unsavedChangesWarning?: string;
  };
  refetchQueries?: string[];
  initialVariables?: Partial<FormData>;
  fullScreen?: boolean;
  maxWidth?: Breakpoint | false;
  // Предупреждения о несохраненных изменениях
  warnOnUnsavedChanges?: boolean;
  unsavedChangesWarningMessage?: string;
}

export function CrudCreateDialog<FormData = any>({
  open,
  onClose,
  onSubmitSuccess,
  createSchema,
  texts,
  refetchQueries,
  initialVariables,
  fullScreen = true,
  maxWidth = false,
  warnOnUnsavedChanges,
  unsavedChangesWarningMessage,
}: CrudCreateDialogProps<FormData>) {
  const steps = [
    {
      label: createSchema.main.label,
      selected: true,
    },
  ];

  const {
    schema,
    label,
    createMutation,
    paper,
    warnOnUnsavedChanges: schemaWarnOnUnsavedChanges,
    unsavedChangesWarningMessage: schemaUnsavedChangesWarningMessage,
  } = createSchema.main;

  const [createItem] = useMutation(createMutation, {
    refetchQueries,
    awaitRefetchQueries: true,
  });

  return (
    <CrudDialog
      open={open}
      onClose={onClose}
      steps={steps}
      title={texts.createItem}
      subTitle={label}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
    >
      <Form
        schema={schema}
        initialValues={Object.assign({}, initialVariables)}
        onSubmit={(input: Record<string, any>) =>
          createItem({ variables: { input } })
        }
        onSubmitSuccess={onSubmitSuccess}
        submitButton={false}
        resetButton={false}
        paper={paper !== false}
        warnOnUnsavedChanges={
          warnOnUnsavedChanges ?? schemaWarnOnUnsavedChanges
        }
        unsavedChangesWarningMessage={
          unsavedChangesWarningMessage ??
          schemaUnsavedChangesWarningMessage ??
          texts.unsavedChangesWarning
        }
        header={({ disabled }: { disabled: boolean }) => (
          <CrudDialogHeader
            position="absolute"
            saveButton
            onClose={onClose}
            secondary={fullScreen ? texts.createItem : ""}
            primary={label}
            disabled={disabled}
          />
        )}
      />
    </CrudDialog>
  );
}
